import { render, staticRenderFns } from "./FilterSummaryCategoryItemCategory.vue?vue&type=template&id=6b259fc8&"
import script from "./FilterSummaryCategoryItemCategory.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryCategoryItemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports